import React, { useState } from "react";
import axios from "axios";
import routes from "../../app/routes";
import { Button, Modal } from "react-bootstrap";
import Form from "./Form";
import Table from "./Table";

//workType: AdminChangeMember, AdminChangeCoach, CoachingPlanChangeCoach, CoachChangeCoach
export default function Index() {
  return (
    <>
      <div className="top-header-info">
        <div className="row">
          <div className="col-md-12">
            <h2>Coach Change Request</h2>
            <hr />
          </div>
        </div>
      </div>
      <div className="ibox-content mt20">
        <Table />
      </div>
    </>
  );
}
